/**
 * Contract Status Constants
 * 계약 상태 관련 상수
 */

/** 계약 상태 코드 */
export const CONTRACT_STATUS = {
    /** 계약중 */
    UNDER_CONTRACT: 'UNDER_CONTRACT',
    /** 계약종료 */
    TERMINATED_CONTRACT: 'TERMINATED_CONTRACT',
    /** 활성 */
    ACTIVE: 'ACT',
} as const;

/** 계약 상태 라벨 */
export const CONTRACT_STATUS_LABELS: Record<string, string> = {
    [CONTRACT_STATUS.UNDER_CONTRACT]: '계약중',
    [CONTRACT_STATUS.TERMINATED_CONTRACT]: '계약종료',
};

/** 활성 상태 값 목록 (Badge에서 활성으로 판단하는 값들) */
export const ACTIVE_STATUS_VALUES = [
    CONTRACT_STATUS.UNDER_CONTRACT,
    CONTRACT_STATUS.ACTIVE,
    '계약중',
    'contract',
    'active'
] as const;

/**
 * 활성 상태 여부 확인
 * @param status 상태 값
 */
export const isActiveStatus = (status: string): boolean => {
    return ACTIVE_STATUS_VALUES.includes(status as typeof ACTIVE_STATUS_VALUES[number]);
};
